"use strict";

window.shell = makeShell();
window.editor = makeEditor();
window.graphics = makeGraphics();
window.gui = makeGUI();
window.gui.init();
